function PreloaderShown(e, dotNetHelper) {
    //var App = document.getElementById("app");
    //App.classList.add("h-100");
    dotNetHelper.invokeMethodAsync('bsShownPreloader',e);
}